import { Label, Select } from '@/components/FormElements';
import Legend from '@/components/Editor/Form/fields/Legend';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const WidgetEditFormPieDoughnutLegend = _ref => {
  let {
    nameSpace,
    template,
    exampleLabel,
    legendType,
    legendPosition,
    legends,
    legendsCount,
    openButtonVariant,
    onChange,
    onChangeTemplate,
    onEditSelections
  } = _ref;
  const legendTypeValue = legendType || 'default';
  return /*#__PURE__*/_jsx(Legend, {
    nameSpace: nameSpace,
    label: "Labels",
    templateLabel: "Label Format",
    editSelectionsLabel: "Edit Label Selections",
    hasLegend: Boolean(legendTypeValue) && legendTypeValue !== 'none',
    legends: legends,
    legendPosition: legendPosition,
    legendsCount: legendsCount,
    hasLegendPosition: legendTypeValue === 'default',
    hasLegendInputs: true,
    hasTemplate: true,
    hasCaption: false,
    template: template,
    exampleLabel: exampleLabel,
    openButtonVariant: openButtonVariant,
    customFields: /*#__PURE__*/_jsx(LegendTypeSelect, {
      type: legendTypeValue,
      onChange: val => onChange({
        legendType: val
      })
    }),
    onChange: onChange,
    onToggleLegend: checked => onChange({
      legendType: checked ? 'default' : 'none'
    }),
    onChangeTemplate: onChangeTemplate,
    onEditSelections: onEditSelections
  });
};

export const LegendTypeSelect = _ref2 => {
  let {
    type,
    onChange
  } = _ref2;
  return /*#__PURE__*/_jsx(Label, {
    className: parentStyles.formField,
    text: "Type",
    children: /*#__PURE__*/_jsxs(Select, {
      defaultValue: type,
      onChange: evt => onChange(evt.currentTarget.value),
      children: [/*#__PURE__*/_jsx("option", {
        value: "default",
        children: "Default"
      }), /*#__PURE__*/_jsx("option", {
        value: "bars",
        children: "Bars"
      })]
    })
  });
};
export default WidgetEditFormPieDoughnutLegend;